/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';

const style: ouiStyle.InStyleWithMediaQueries = {
  widthLines: 'full',
  paddingBottom: ['none', undefined, undefined, 1, undefined, undefined],
  paddingHorizontal: 'none',
};

export const LinkedBondsElementWrapper = (props: React.PropsWithChildren<{
  position?: ouiStyle.InStyleWithMediaQueries['position'],
  top?: ouiStyle.InStyleWithMediaQueries['top'],
  bottom?: ouiStyle.InStyleWithMediaQueries['bottom'],
  left?: ouiStyle.InStyleWithMediaQueries['left'],
  right?: ouiStyle.InStyleWithMediaQueries['right'],
  transform?: ouiStyle.InStyleWithMediaQueries['transform'],
}>) => {
  const {
    position,
    top,
    bottom,
    left,
    right,
    transform,
    children,
  } = props;
  const css = React.useMemo(
    () => ouiStyle.mediaQuery({
      ...ouiStyle.makeCss({
        ...style,
        transform,
        position,
        top,
        bottom,
        left,
        right,
      }),
      transitionProperty: 'transform',
      transitionDuration: '0.2s',
    }),
    [
      transform,
      position,
      top,
      bottom,
      left,
      right,
    ],
  );
  return (
    <div
      css={css}
    >
      {children}
    </div>
  );
};
